

function CarouselIamge(props){

    const { id, name,src,onClick} = props
    
    return(
         <div className="flex one center">
                <img src={src} className='car-img shadow' id="car-img" onClick={onClick}></img>
         </div>
    )
}

export default CarouselIamge;